import { useState, useRef, useEffect } from 'react';

export interface TextRevealProps {
  /** The text */
  text: string;
}

/** Block revealing text */
export const TextReveal = ({ text }: TextRevealProps) => {
  const ref: React.MutableRefObject<HTMLDivElement | null> = useRef(null);
  const [highlight, setHighlight] = useState('');
  const [other, setOther] = useState(text);

  const highlightText = () => {
    if (!ref.current) {
      return;
    }

    const rect = ref.current.getBoundingClientRect(),
      vHeight = window.innerHeight || document.documentElement.clientHeight,
      pxPerChar = vHeight / text.length / 2,
      chars = (vHeight - rect.top * 2) / pxPerChar;

    setHighlight(text.substring(0, chars));
    setOther(text.substring(chars));
  };

  useEffect(() => {
    window.addEventListener('scroll', highlightText, { passive: true });
    window.requestAnimationFrame(() => {
      highlightText();
    });
    return () => {
      window.removeEventListener('scroll', highlightText);
    };
  });

  return (
    <div className="text-reveal" ref={ref}>
      <span>{highlight}</span>
      <span>{other}</span>
    </div>
  );
};
